module.exports = __webpack_public_path__ + "media/images/photos/9-0c6df4350a9b869b7c120370b40dc2fb.jpg";